import React from 'react';
import ConfirmationModal from '../../../Base/Components/Confirmation/ConfirmationModal';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
// @ts-ignore
import styles from './LaboratorySetupAllowConfirmationModal.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	onConfirm: () => void;
	onClose: () => void;
	laboratoryName: string;
}

const LaboratorySetupAllowConfirmationModal: React.FC<Props> = ({
	onConfirm,
	laboratoryName,
	onClose,
}) => {
	const { t } = useTranslation();
	const { showNotificationAlert } = useNotification();

	const handleCancel = () => {
		showNotificationAlert({
			content: t(
				'component.laboratorySetupAllowConfirmationModal.cancelMessage',
			),
		});
		onClose();
	};

	return (
		<ConfirmationModal
			title='component.laboratorySetupAllowConfirmationModal.title'
			text={`${t(
				'component.laboratorySetupAllowConfirmationModal.text',
			)} ${laboratoryName} ?`}
			isOpen
			onClose={onClose}>
			<div className={styles.buttons}>
				<Button
					theme={Theme.GREEN}
					onClick={onConfirm}
					title='component.laboratorySetupAllowConfirmationModal.confirm'
				/>
				<LinkButton
					title='component.laboratorySetupAllowConfirmationModal.cancel'
					theme={Theme.RED}
					onClick={handleCancel}
				/>
			</div>
		</ConfirmationModal>
	);
};

export default LaboratorySetupAllowConfirmationModal;
